const OurTeam = () => {
	return null;
};

export default OurTeam;
